import { Group, Progress, Stack, Text, Tooltip, useMantineTheme } from '@mantine/core'
import { IconShieldCheck } from '@tabler/icons-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const getConfidenceColor = (confidence: number, theme: any) => {
  if (confidence < 0.33) return theme.colors.notification[0] // Red
  if (confidence < 0.66) return theme.colors.barChartYellow[0] // Yellow
  return theme.colors.barChartGreen[0] // Green
}
interface ElectionConfidenceProps {
  verifiedVoters: number
  numVoters: number
}

const ElectionConfidence: React.FC<ElectionConfidenceProps> = ({ verifiedVoters, numVoters }) => {
  const { t } = useTranslation()
  const theme = useMantineTheme()
  return (
    <Tooltip
      label={t(
        'components.governance.results.confidenceTooltip',
        'Verifying your votes helps validate your participation and increase community-wide confidence in the latest election.'
      )}
    >
      <Stack style={{ minWidth: '200px' }} gap="xs">
        <Group justify="space-between" mb={5}>
          <Text size="sm" c={theme.colors.paragraph[0]}>
            {t('components.governance.results.confidence', 'Votes Verified')}
          </Text>
          <Group gap={5}>
            <IconShieldCheck
              size={16}
              color={getConfidenceColor(verifiedVoters / numVoters, theme)}
              style={{ opacity: 0.9 }}
            />
            <Text size="sm" fw={500} c={theme.colors.title[0]}>
              {Math.round((verifiedVoters / numVoters) * 100)}%
            </Text>
          </Group>
        </Group>
        <Progress.Root size="sm">
          <Tooltip
            label={`${verifiedVoters} ${t('components.governance.results.verifiedVoters', 'verified voters')} / ${numVoters} ${t('components.governance.results.totalVoters', 'total voters')}`}
          >
            <Progress.Section
              value={(verifiedVoters / numVoters) * 100}
              color={getConfidenceColor(verifiedVoters / numVoters, theme)}
            />
          </Tooltip>
        </Progress.Root>
      </Stack>
    </Tooltip>
  )
}

export default ElectionConfidence
